/**
 * DebugPanel — HUD element (extracted from PixiHUDRenderer.js in Phase 3D).
 *
 * create(hud) builds the PIXI objects into hud.elements.debugPanel,
 * position(hud) lays them out for hud.screenWidth/Height, update(hud, …) redraws
 * from game state. `hud` is the PixiHUDRenderer coordinator: it owns
 * hudContainer, elements, screen size, _createText() and send().
 */
import * as PIXI from 'pixi.js';

/**
 * Create debug panel
 */
export function create(hud) {
  const container = new PIXI.Container();
  container.visible = false;
  hud.hudContainer.addChild(container);

  const background = new PIXI.Graphics();
  container.addChild(background);

  const titleText = hud._createText('DEBUG MODE', 14, 0x00ff00, true);
  const statsText = hud._createText('', 14, 0xffffff);
  const coordsText = hud._createText('', 14, 0xffffff);

  container.addChild(titleText);
  container.addChild(statsText);
  container.addChild(coordsText);

  hud.elements.debugPanel = { container, background, titleText, statsText, coordsText };
}

/**
 * Update debug panel
 * @param {Object} debugInfo - Debug information object
 */
export function update(hud, debugInfo) {
  const dp = hud.elements.debugPanel;
  if (!dp) return;

  const { debugMode, mouseWorldX, mouseWorldY, fps, ping, rendererType, netStats } = debugInfo;

  // Show/hide based on DEBUG_MODE
  if (!debugMode) {
    dp.container.visible = false;
    return;
  }
  dp.container.visible = true;

  const x = 30;
  // Clear of a full five-line kill feed above it (30 + 5 * 35 lineHeight).
  const y = 215;
  const padding = 10;
  const debugWidth = 240 * 0.65 + (netStats ? 110 : 0);
  const debugHeight = 60 * 1.15 * 2 + (netStats ? 34 : 0);

  dp.container.x = x;
  dp.container.y = y;

  // Background
  dp.background.clear();
  dp.background.rect(0, -18, debugWidth, debugHeight);
  dp.background.fill({ color: 0x000000, alpha: 0.7 });

  // Title
  dp.titleText.x = padding;
  dp.titleText.y = 0;

  // Stats (FPS, Ping, Renderer)
  const net = netStats
    ? `\nRTT ${netStats.rtt}ms  jitter95 ${netStats.jitter95}ms  interp ${netStats.interp}ms\nsnap ${netStats.interval ?? '–'}ms  corr ${netStats.correctionsPerMin}/min (${netStats.meanCorrection}px)  ${netStats.transport || ''}`
    : '';
  dp.statsText.text = `FPS: ${fps || 0} | Ping: ${ping || 0}ms\nRenderer: ${rendererType || 'WebGL'}${net}`;
  dp.statsText.x = padding;
  dp.statsText.y = 20;

  // Coords
  dp.coordsText.text = `World X: ${mouseWorldX}\nWorld Y: ${mouseWorldY}`;
  dp.coordsText.x = padding;
  dp.coordsText.y = 55 + (netStats ? 34 : 0);
}
